export const HOME_HERO_TITLES = [
  'Building cinematic stories and intelligent digital experiences.',
  'Creating worlds through storytelling, technology, and design.',
  'Where imagination meets modern technology.',
  'Original stories. Intelligent systems. One creative universe.',
  'Stories, software, and worlds built for what comes next.'
];

export const ABOUT_HERO_TITLES = [
  'Built at the intersection of storytelling and technology.',
  'One creative vision across stories, software, and media.',
  'Where cinematic storytelling meets modern technology.',
  'Technology with imagination at its core.',
  'Designed for creators, readers, and the future.'
];

export const PROJECTS_HERO_TITLES = [
  'Projects shaping the future of stories and technology.',
  'A growing universe of creative and technical work.',
  'Where ideas become immersive experiences.',
  'Every project starts with imagination.',
  'Projects built beyond traditional boundaries.'
];

export const PUBLISHING_HERO_TITLES = [
  'Creating stories beyond the page.',
  'Built for readers, dreamers, and explorers.',
  'Stories designed to stay with you.',
  'Creative storytelling for a new generation.',
  'Every world begins with a story.'
];

export const CODING_HERO_TITLES = [
  'Building modern apps and digital platforms.',
  'Intelligent platforms engineered for the future.',
  'Modern apps, platforms, and AI-driven experiences.',
  'Built with architecture, powered by innovation.',
  'Technology designed to scale with imagination.'
];
